// extracted by mini-css-extract-plugin
export var borderRadius = "_g2-4";
export var large = "_g2-3";
export var logoContainer = "_g2-0";
export var nameLogo = "_g2-2";
export var small = "_g2-1";